import { render, staticRenderFns } from "./DownIcon.vue?vue&type=template&id=002b92da&"
import script from "./DownIcon.vue?vue&type=script&lang=ts&"
export * from "./DownIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports